import type { TRankingCriteria } from '../_types'

export const HOME_EVENT = {
  PAGE_SHOW: 'common_web_modoocar_page_show',
  SECTION_SHOW: 'common_web_modoocar_section_show',
  ITEM_SHOW: 'common_web_modoocar_item_show',
  ITEM_CLICK: 'common_web_modoocar_item_click',
  LOGO_CLICK: 'common_web_modoocar_logo_click',
} as const

export const HOME_TRACK_CODE = {
  PAGE: 'page',
  HEADER: 'header',
  HERO: 'hero',
  HOME_RANK: 'home_rank',
  APP_DOWNLOAD: 'app_download',
  FOOTER: 'footer',
} as const

export const HOME_TRACK_TYPE = {
  PAGE: 'page',
  LOGO: 'logo',
  SECTION: 'section',
  SEARCH_BAR: 'search_bar',
  BUTTON: 'button',
  CHIP: 'chip',
  LIST_ITEM: 'list_item',
  FOOTER: 'footer',
} as const

export const HOME_TRACK_LABEL = {
  PAGE: '모두의 차고 홈',
  LOGO: '마이클 로고',
  HERO_SECTION: '히어로 영역',
  HERO_SEARCH: '검색',
  RANK_SECTION: '차종 랭킹 TOP5',
  RANK_MORE: '전체보기',
  APP_SECTION: '앱 다운로드',
  APP_BUTTON: '마이클 앱 다운받기',
  FOOTER: '최하단',
} as const

export const buildRankItemClickLabel = (carName: string): string =>
  `랭킹 항목 클릭 | ${carName}`

export const RANK_TYPE_LABEL: Record<TRankingCriteria, string> = {
  satisfaction: '만족도',
  fuelEfficiency: '실연비',
  fuelCost: '유류비',
}

export const DEFAULT_RANK_TYPE = RANK_TYPE_LABEL.satisfaction
